import { DevTools } from "jotai-devtools";

import "jotai-devtools/styles.css";

export const StateDevTools = () => {
  return <DevTools />;
};
